export default __webpack_public_path__ + "458b107bd7dfb4152b8a5e6d5125d3ef.svg";